import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WarningIcon } from '../../assets/images/warning-triangle-icon.svg';
import './LockBanner.scss';

const LockBanner = ({ 
    visible = false, 
    lockedBy = null, 
}) => {
    const { t } = useTranslation();

    if (!visible) {
        return null;
    }

    return (
        <div className="lock-banner">
            <div className="lock-banner-content">
                <div className="lock-banner-icon">
                    <WarningIcon />
                </div>
                <div className="lock-banner-text">
                    <span className="lock-banner-title">
                        {t('planogram.lockBanner.title')}
                    </span>
                    <span className="lock-banner-separator"> - </span>
                    <span className="lock-banner-message">
                        {t('planogram.lockBanner.message', { 
                            lockedBy: lockedBy || t('planogram.lockBanner.unknownUser')
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LockBanner;
